import { render, staticRenderFns } from "./DeliveryFormDetailsResearch.vue?vue&type=template&id=5cd5eb49&scoped=true&"
import script from "./DeliveryFormDetailsResearch.vue?vue&type=script&lang=js&"
export * from "./DeliveryFormDetailsResearch.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryFormDetailsResearch.vue?vue&type=style&index=0&id=5cd5eb49&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd5eb49",
  null
  
)

export default component.exports